import React, { useEffect, useReducer } from 'react'

import {
    Box, Dialog, DialogActions, DialogContent, DialogTitle,
    Tooltip, Button, TextField, Divider, Select, MenuItem, InputLabel, FormControl, Chip,
    FormControlLabel, FormGroup, Switch
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import api from '../../../../api';
import useNotification from '../../../Notification';

import defaultReducer from '../../../../utils/defaultReducer';
import CancelIcon from '@mui/icons-material/Cancel';
import { alphabeticalSort } from '../../../../utils/alphabeticalSort';


const action = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const normalizeJoinEmptyToBool = (value) => {
    if (value === true || value === 1) return true;
    if (value === false || value === 0) return false;

    const s = String(value ?? "").trim().toLowerCase();
    if (["1", "yes", "y", "true", "sim"].includes(s)) return true;
    if (["0", "no", "n", "false", "não", "nao"].includes(s)) return false;

    return false; // fallback seguro
};

const UsersQueueEditModal = ({ data, setData, getRows, enterpriseId, setLoading, users, has_voice, voiceOnly = false }) => {
    const [state, setState] = useReducer(defaultReducer, {
        description: '',
        type: voiceOnly ? 1 : 0,
        users: [],
        joinempty: true,
        queue_position_enabled: false,
        queue_position_interval: 60,
        queue_position_initial_message: '',
        queue_position_update_message: '',
        queue_position_include_ewt: true,
        queue_position_ewt_type: 0,
    })

    const checkButtonText = () => {
        const text = []

        if (state.description.length == 0)
            text.push(<Box>Nome não pode estar vazio.</Box>)

        if (state.queue_position_enabled && Number(state.queue_position_interval) < 60)
            text.push(<Box>O intervalo de atualização deve ser de no mínimo 60 segundos.</Box>)

        if (text.length == 0)
            return ''

        return (text)
    }

    useEffect(async () => {
        if (!data.id) {
            setState({
                description: '',
                type: voiceOnly ? 1 : 0,
                users: [],
                joinempty: true,
                queue_position_enabled: false,
                queue_position_interval: 60,
                queue_position_initial_message: '',
                queue_position_update_message: '',
                queue_position_include_ewt: true,
                queue_position_ewt_type: 0,
            })
            return
        }

        let selected_users = []
        let selected_type = 0
        if (data.type == 'Chat')
            selected_users = users.sort((x,y) => alphabeticalSort(x,y, 'first_name')).filter(each => each.profile.queues.filter(queue => queue.id === data.id).length > 0).map(each => each.profile.agent_id)
        else {
            selected_users = data.queue_members.map(each => each.agents_id)
            selected_type = 1
        }

        setState({
            description: data.description,
            type: selected_type,
            users: selected_users,
            joinempty: normalizeJoinEmptyToBool(data.joinempty),
            queue_position_enabled: !!data.queue_position_enabled,
            queue_position_interval: data.queue_position_interval ?? 60,
            queue_position_initial_message: data.queue_position_initial_message ?? '',
            queue_position_update_message: data.queue_position_update_message ?? '',
            queue_position_include_ewt: data.queue_position_include_ewt ?? true,
            queue_position_ewt_type: data.queue_position_ewt_type ?? 0,
        })

    }, [data])

    const submit = async () => {
        let res = null
        const type = state.type == 0 ? 'chat/' : 'voice/'
        const url = `api/enterprises/${enterpriseId}/queues/${type}`

        const parts = (data.name || "").split("_")
        if (parts[1]?.startsWith("0000") && state.users.length !== 1) {
            useNotification("Atenção", "Esta fila NÃO pode conter mais de UM usuário.", "warning")
            return
        }
        const payload = {
            ...state,
            joinempty: state.joinempty ? 1 : 0,
            queue_position_enabled: state.queue_position_enabled ? 1 : 0,
            queue_position_interval: Number(state.queue_position_interval),
            queue_position_include_ewt: state.queue_position_include_ewt ? 1 : 0,
            queue_position_ewt_type: Number(state.queue_position_ewt_type),
        }

        setLoading(true)
        if (!data?.id)
            res = await api.post(url, payload, { timeout: 0 })
        else
            res = await api.patch(url + `${data.id}/`, payload, { timeout: 0 })
        setLoading(false)

        if (!(res.status === 200 || res.status === 201)) {
            let errorMessage = `Não foi possível ${action(data)} a fila.`
            if (res.status == 500) {
                if (res?.data?.error?.pop() === 10)
                    errorMessage = 'Não é possivel deixar um agente sem fila.'
            }
            useNotification(
                'Ops!',
                errorMessage,
                'danger'
            )
            getRows()
            setData()
            return
        }
        getRows()
        setData()
        useNotification(
            'Sucesso!',
            `Fila ${res.status == 201 ? 'adicionada' : 'atualizada'} com sucesso.`,
            'success'
        )
    }

    return (
        <>
            <Dialog open={true}
                fullWidth
                disablePortal
                disableEnforceFocus
                sx={{ position: 'absolute' }}
            >
                <DialogTitle
                    id="customized-dialog-title" className={'group-flexbox'}>
                    <span>{action(data)} Fila</span>
                    <Tooltip title="Fechar" >
                        <Button className="action-button"  >
                            <CloseIcon onClick={() => { setData() }} />
                        </Button>
                    </Tooltip>
                </DialogTitle>
                <Divider />
                <DialogContent className='piloto-modal-flex'>
                    <TextField
                        size='small'
                        label='Nome'
                        value={state.description}
                        onChange={(e) => setState({ description: e.target.value })}
                    />

                    {(!data.id && has_voice && !voiceOnly) && <Box className='BuilderBotSelectorBox'>
                        <Button
                            variant={state.type === 0 ? 'contained' : ''}
                            onClick={() => setState({ type: 0 })}
                        >
                            Chat
                        </Button>
                        <Button
                            variant={state.type === 1 ? 'contained' : ''}
                            onClick={() => setState({ type: 1 })}
                        >
                            Voz
                        </Button>
                    </Box>}

                    <FormControl fullWidth>
                        <InputLabel size='small' id='select-on-users-queue'>Usuários</InputLabel>
                        <Select
                            multiple
                            size='small'
                            labelId={'select-on-users-queue'}
                            label='Usuários'
                            value={state.users}
                            onChange={(e) => setState({ users: e.target.value })}
                            renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected.map((value) => {
                                        
                                        const user = users.find(user => user.profile.agent_id === value)

                                        return (
                                            <Chip
                                            size="small"
                                            key={value}
                                            className={!user?.is_active ? 'hide-from-list' : ''}
                                            label={`${user?.first_name} ${user?.last_name}`}
                                            deleteIcon={
                                                <CancelIcon
                                                    onMouseDown={(event) => event.stopPropagation()}
                                                />}
                                            onDelete={() => setState({ users: state.users.filter(each => each !== value) })}
                                        />
                                        )
                                    }
                                        
                                    )}
                                </Box>
                            )}
                        >
                            {users.sort((x,y) => alphabeticalSort(x,y, 'first_name')).map(user => (
                                <MenuItem
                                    className={(state.users.includes(user.profile.agent_id) || !user.is_active) ? 'hide-from-list' : ''}
                                    value={user.profile.agent_id} data={user}>
                                    {user.first_name} {user.last_name}
                                </MenuItem>
                            ))}

                        </Select>
                        <FormGroup aria-label="position" row>
                            <FormControlLabel
                                sx={{ marginLeft: ".25rem" }}
                                label="Espera sem operadores"
                                labelPlacement="start"
                                control={
                                    <Switch
                                        color="primary"
                                        checked={!!state.joinempty}
                                        onChange={() => setState({ joinempty: !state.joinempty })}
                                    />
                                }
                            />
                        </FormGroup>
                    </FormControl>

                    <Divider />

                    <FormControl fullWidth>
                        <FormGroup aria-label="queue-position" row>
                            <FormControlLabel
                                sx={{ marginLeft: ".25rem" }}
                                label="Informar posição na fila"
                                labelPlacement="start"
                                control={
                                    <Switch
                                        color="primary"
                                        checked={!!state.queue_position_enabled}
                                        onChange={() => setState({ queue_position_enabled: !state.queue_position_enabled })}
                                    />
                                }
                            />
                            <Button
                                size="small"
                                onClick={() => window.open("https://instant.getoutline.com/s/mensagens-posicao-fila", "_blank")}
                            >
                                FAQ
                            </Button>
                        </FormGroup>
                    </FormControl>

                    {state.queue_position_enabled && <>
                        <TextField
                            size='small'
                            type='number'
                            label='Intervalo de atualização (segundos)'
                            value={state.queue_position_interval}
                            inputProps={{ min: 60 }}
                            onChange={(e) => setState({ queue_position_interval: e.target.value })}
                            helperText='Mínimo de 60 segundos'
                        />

                        <TextField
                            size='small'
                            multiline
                            minRows={2}
                            label='Mensagem inicial'
                            value={state.queue_position_initial_message}
                            onChange={(e) => setState({ queue_position_initial_message: e.target.value })}
                        />

                        <TextField
                            size='small'
                            multiline
                            minRows={2}
                            label='Mensagem de atualização'
                            value={state.queue_position_update_message}
                            onChange={(e) => setState({ queue_position_update_message: e.target.value })}
                        />

                        <FormControl fullWidth>
                            <FormGroup aria-label="queue-position-ewt" row>
                                <FormControlLabel
                                    sx={{ marginLeft: ".25rem" }}
                                    label="Incluir EWT na mensagem"
                                    labelPlacement="start"
                                    control={
                                        <Switch
                                            color="primary"
                                            checked={!!state.queue_position_include_ewt}
                                            onChange={() => setState({ queue_position_include_ewt: !state.queue_position_include_ewt })}
                                        />
                                    }
                                />
                            </FormGroup>
                        </FormControl>

                        {state.queue_position_include_ewt &&
                            <FormControl fullWidth size='small'>
                                <InputLabel id='queue-position-ewt-type-label'>Tipo de EWT</InputLabel>
                                <Select
                                    labelId='queue-position-ewt-type-label'
                                    label='Tipo de EWT'
                                    value={state.queue_position_ewt_type}
                                    onChange={(e) => setState({ queue_position_ewt_type: e.target.value })}
                                >
                                    <MenuItem value={0}>Maior espera atual (Longest)</MenuItem>
                                    <MenuItem value={1}>Média do dia (AverageDay)</MenuItem>
                                    <MenuItem value={2}>Service Level - Janela 1</MenuItem>
                                    <MenuItem value={3}>Service Level - Janela 2</MenuItem>
                                    <MenuItem value={4}>Service Level - Janela 3</MenuItem>
                                </Select>
                            </FormControl>
                        }
                    </>}
                </DialogContent >
                <DialogActions style={{ padding: "10px 20px 10px 10px" }}>
                    <Button
                        onClick={() => { setData() }}>
                        Cancelar
                    </Button>
                    <Tooltip title={checkButtonText()} placement="top" describeChild={true}>
                        <span>
                            <Button
                                disabled={checkButtonText()}
                                onClick={submit}>
                                Salvar
                            </Button>
                        </span>
                    </Tooltip>
                </DialogActions>
            </Dialog >
        </>
    )
}

export default UsersQueueEditModal
